import { inject, Injectable } from '@angular/core';
import { CollaborationScreenService } from '@libs/collaboration';
import { ComponentStore } from '@ngrx/component-store';

const initialState = {
  filterUnreadOnly: false,
  filterDirectOnly: true,
  filterTeamCollab: false,
  filterClinicalCollab: false,
};

interface MyCollaborationsSidebarState {
  filterDirectOnly: boolean;
  filterUnreadOnly: boolean;
  filterTeamCollab: boolean;
  filterClinicalCollab: boolean;
}

@Injectable({ providedIn: 'root' })
export class MyCollaborationsFilterService extends ComponentStore<MyCollaborationsSidebarState> {
  private readonly collabScreenService = inject(CollaborationScreenService);

  constructor() {
    super(initialState);
  }

  public updateFilters({
    directOnly,
    unreadOnly,
    teamCollab,
    clinicalCollab,
  }: {
    directOnly: boolean;
    unreadOnly: boolean;
    teamCollab: boolean;
    clinicalCollab: boolean;
  }): void {
    const { filterDirectOnly, filterUnreadOnly, filterTeamCollab, filterClinicalCollab } = this.state();

    const directOnlyChanged = directOnly !== filterDirectOnly;
    const unreadOnlyChanged = unreadOnly !== filterUnreadOnly;
    const teamCollabChanged = teamCollab !== filterTeamCollab;
    const clinicalCollabChanged = clinicalCollab !== filterClinicalCollab;

    if (!directOnlyChanged && !unreadOnlyChanged && !teamCollabChanged && !clinicalCollabChanged) {
      return;
    }

    this.patchState({
      filterDirectOnly: directOnly,
      filterUnreadOnly: unreadOnly,
      filterTeamCollab: teamCollab,
      filterClinicalCollab: clinicalCollab,
    });
    this.collabScreenService.updateFilters({
      filters: { directOnly, unreadOnly, teamCollab, clinicalCollab },
      clearCollabs: false,
      fetchCollabs: true,
    });
  }
}
